import { render } from "./BaseLabelTooltip.vue?vue&type=template&id=6a06acf9&scoped=true"
import script from "./BaseLabelTooltip.vue?vue&type=script&lang=js"
export * from "./BaseLabelTooltip.vue?vue&type=script&lang=js"

import "./BaseLabelTooltip.vue?vue&type=style&index=0&id=6a06acf9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a06acf9"]])

export default __exports__